import React from 'react';
import { motion } from 'framer-motion';
export function SelfCare() {
  return <section className="py-12 px-4 bg-cream" data-id="element-399">
      <div className="max-w-4xl mx-auto" data-id="element-400">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-401">
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto" data-id="element-402">
            El autocuidado del que habla este libro no es lujo.
          </p>
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto mt-2" data-id="element-403">
            Es supervivencia emocional.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative" data-id="element-404">
          <div className="absolute inset-0 bg-terracotta/10 transform rotate-1 rounded-2xl" data-id="element-405" />
          <img src="https://cdn.magicpatterns.com/uploads/25ioD5LasrcWUfQNWgdwzM/image.png" alt="Autocuidado realista: no es spa, es supervivencia" className="relative rounded-2xl shadow-xl w-full" data-id="element-406" />
        </motion.div>

        <p className="text-center text-lg md:text-xl text-navy/70 italic font-medium mt-6" data-id="element-407">
          El libro incluye herramientas simples como estas para ayudarte a
          recuperar energía mientras sigues cuidando.
        </p>
      </div>
    </section>;
}